// extracted by mini-css-extract-plugin
module.exports = {"xIcon":"style_xIcon__teBUX"};